module.exports = __webpack_public_path__ + "img/ClearwaterCreditUnion.19be6d1a.svg";